module.exports = __webpack_public_path__ + "static/media/Dashboard.7bfa62c6.svg";